export default __webpack_public_path__ + "static/media/TT Norms Pro Regular.afdec721.otf";